import PropTypes from 'prop-types';
import { useMediaQuery, useTheme } from '@mui/material';
import CustomModal from './CustomModal';
import CustomDrawer from './CustomDrawer';

ResponsiveModal.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  open: PropTypes.bool,
  actions: PropTypes.node,
  onClose: PropTypes.func,
  hasClose: PropTypes.bool,
  children: PropTypes.node,
  isBackdropClosable: PropTypes.bool,
  hasTransition: PropTypes.bool,
  paperPropsSx: PropTypes.object,
};

export default function ResponsiveModal({
  children,
  title = '',
  actions,
  open,
  onClose,
  hasClose = true,
  isBackdropClosable = true,
  paperPropsSx,
  ...other
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (isMobile) {
    return (
      <CustomDrawer
        open={open}
        onClose={onClose}
        title={title}
        actions={actions}
        hasClose={hasClose}
        isBackdropClosable={isBackdropClosable}
        paperPropsSx={paperPropsSx}
        {...other}
      >
        {children}
      </CustomDrawer>
    );
  }

  return (
    <CustomModal
      open={open}
      onClose={onClose}
      title={title}
      actions={actions}
      hasClose={hasClose}
      isBackdropClosable={isBackdropClosable}
      paperPropsSx={paperPropsSx}
      {...other}
    >
      {children}
    </CustomModal>
  );
}
